/* eslint-disable react/prop-types */
import React, { FunctionComponent } from "react";

import { ProductPageHero } from "../blocks/Hero/ProductPageHero";
import { SearchFormLanding } from "../blocks/SearchForm/SearchFormLanding";
import { productTypeWheel } from "../constants/productTypes";

export const DealerWheelsPage: FunctionComponent = () => {
  return (
    <>
      <ProductPageHero />
      <SearchFormLanding productType={productTypeWheel} />
    </>
  );
};
